/**************************************************
 * Nombre:       Tarjeta_Piso_Vista
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Divider, Grid, Typography} from "@mui/material";
import Tarjeta_Habitacion_Vista from "./Tarjeta_Habitacion_Vista";

const Tarjeta_Piso_Vista = ({piso, click, reservasDia, fechaDia}) => {


    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'center'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Grid container size={{xs: 12, sm: 12, md: 12}} justifyContent={'center'}>
                <Divider sx={{width: '100%', px: 2}}><Typography
                    sx={{
                        fontSize: 16,
                        fontWeight: 800,
                        px: 2,
                        color: '#00000090'
                    }}>{`Piso ${piso.piso}`}</Typography></Divider>

            </Grid>

            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}} sx={{mt: 4, mb: 4, px: 3}}
                spacing={4}>


                {piso?.habitaciones?.map((it, index) => {
                    return (
                        <Grid container size={{xs: 4, sm: 3, md: 3}} justifyContent={'center'}>
                            <Tarjeta_Habitacion_Vista item={it} click={click} reservasDia={reservasDia}
                                                      fechaDia={fechaDia}/>
                        </Grid>
                    )
                })}

            </Grid>

        </Grid>
    )

}
export default Tarjeta_Piso_Vista